import React, {Component} from 'react';
import { Field, Columns } from 'components/elements'
import { apiProcess } from '../../api/api.js'
import { LISTING_OPTIONS_YEARS, bikeBrands, bikeParking } from '../../../constants'
import { MAKE, YEAR } from '../../list/motorcycle/steps/basicDetails/basicUtils/basicConstants.js';
import CoverLoader from 'components/elements/coverLoader'
class MotoLookUp extends Component {
 
    constructor(props) {
        super(props);
        this.state = {
            hasYear : this.props.values.year ? true : false,
            hasMake : this.props.values.make ? true : false,
            brandOptions : bikeBrands,
            modelOptions : [],
            modelSpecifications : null,
            showModelSelect : false,
            parkingOptions : bikeParking,
            parking : null,
            showParkingType: this.props.showParkingType ? true : false
        }
    }

    componentDidMount() {
      //here we check if we need to add a brand or not.
      let brandTest = this.isBrandInList(this.props.values[MAKE])
      let brandOptions = this.state.brandOptions
      let showModelSelect = false
      if(!brandTest) {
        brandOptions.push({
          key: this.props.values[MAKE],
          text: this.props.values[MAKE],
          value: this.props.values[MAKE]
        })
        showModelSelect = false
      } else {
        //if we have a brand, let's get the model list
        showModelSelect = true
        const skipOnMakeChange = this.isModelPreSelected()
        this.handleMakeChange(this.props.values[MAKE], { 'year' : this.props.values[YEAR]}, false, skipOnMakeChange)
      }

      this.setState({
        showModelSelect : showModelSelect,
        brandOptions : brandOptions
      })
    }


    isBrandInList = (brandValue) => {
      let brandExists = false
      for (let i = 0; i < bikeBrands.length; i++) {
        if (bikeBrands[i].value === brandValue) {
          brandExists = true
        }
      }
      return brandExists
    }

    isModelPreSelected = () => {
      const { 
        values, 
        modelID 
      } = this.props
      return !!values[modelID]
    }

    handleYearChange = (value) => {
        this.props.onYearChange(value)
        this.props.onMakeChange("")
        this.props.onModelChange({
          selectedModel : null,
          modelSpecifications : null
        })
        this.setState({
            modelSpecifications : null,
            hasMake : false,
            modelOptions : [],
            hasYear : value ? true : false
        })  
    }

    handleMakeChange = (value, values, skipModel = false, skipOnMakeChange = false) => {
      if (!skipOnMakeChange) {
        this.props.onMakeChange(value)
      }  
        
        if(skipModel) {
          this.props.onModelChange({
            selectedModel : null,
            modelSpecifications : null
          })
          this.setState({
            makeModelLoading: true,
            modelSpecifications : null,
          })

        }
        
        this.setState({
            hasMake : value ? true : false,
            modelOptions : [],
        })  

        let brandTest = this.isBrandInList(value)

        if(brandTest) {
            this.handleMakeChangeData(value, values).then(data => {
                if(data.success) {
                    if(data.modelOptions.length > 0) {
                        this.setState({
                            makeModelLoading: false,
                            modelOptions : data.modelOptions,
                            showModelSelect : true,
                        })
                    } else {   
                        this.setState({
                            makeModelLoading: false,
                            modelOptions : [],
                            showModelSelect : false,
                        })

                    }
                } else { //this should really be a catch. oh well.
                    this.setState({
                        makeModelLoading: false,
                        modelOptions : [],
                        showModelSelect : false,
                    })
                }          
            })
        } 
    }
        
    handleMakeChangeData = (value, values) => {

        let fetchURL = 'motorcycles/stock_inventory?make=' + value + '&year=' + values.year

        return apiProcess(
                fetchURL, 
                false,
                'model-from-make-year', 
                'Make Model Lookup List Bike'
            ).then(function (responseData) {
                
                let modelOptions = []
                responseData.map((model, i) => (
                    modelOptions.push({
                        key: model.id,
                        value: model.model,
                        text: model.model,
                        id: model.id,
                        make: model.make,
                        model: model.model,
                        year: model.year,
                        category: model.category,
                        twisted_road_category: model.twisted_road_category,
                        displacement_cc: model.displacement_cc,
                        dry_weight_kg: model.dry_weight_kg,
                        dry_weight_lb: model.dry_weight_lb,
                        fuel_capacity_liters: model.fuel_capacity_liters,
                        fuel_capacity_gal: model.fuel_capacity_gal,
                        seat_height_mm: model.seat_height_mm,
                        seat_height_in: model.seat_height_in
                    })
                ))

                return {          
                    success : true,
                    modelOptions : modelOptions,
                }
            }).catch(function (errorResponse) {
                return {
                    success : false 
                }    
            });
    }

    handleModelChange = (value) => {
        
        let indexOfModelInfo = null
        let modelSpecifications = null

        if(this.state.modelOptions.length > 0) {
            for (var i=0; i < this.state.modelOptions.length; i++) {
              if (this.state.modelOptions[i].model === value) {
                  indexOfModelInfo = i
                }
            }
        }

        if(indexOfModelInfo !== null) {
                modelSpecifications = this.state.modelOptions[indexOfModelInfo]
        }

        if(indexOfModelInfo === null) {
            modelSpecifications = null
        }

        let modelInfo = {
            selectedModel : value,
            modelSpecifications : modelSpecifications
        }

        this.setState({ 
            modelSpecifications : modelSpecifications
        })
        this.props.onModelChange(modelInfo)

    }

render() {
      
    const { 
      yearID,
      makeID,
      modelID,
      columnSize,
      parkingID,
    } = this.props

    const {
      brandOptions,
      parkingOptions
    } = this.state  

  return (
    <div className="is-relative">
      {this.state.makeModelLoading && <CoverLoader text="Warming Up..." />}

      <Columns>
        <Columns.Column size={columnSize}>
          <Field
            label="Bike Year"
            placeholder="Select Bike Year"
            fullwidth="true"
            type="select"
            options={LISTING_OPTIONS_YEARS}
            id={yearID}
            name={yearID}
            error={this.props.errors[yearID]}
            value={this.props.values[yearID]}
            onChange={({ e, value }) => {
              this.handleYearChange(value)
            }}
          />
        </Columns.Column>
        <Columns.Column size={columnSize}>
          <Field
            label="Make"
            id={makeID}
            placeholder="Search Makes"
            fluidwidth
            type="select"
            error={this.props.errors[makeID]}
            options={brandOptions}
            name={makeID}
            value={this.props.values[makeID]}
            onChange={({ value }) => {
              this.handleMakeChange(value, this.props.values)
            }}
            disabled={!this.state.hasYear}
            loading={this.state.makeModelLoading}
          />
        </Columns.Column>
        <Columns.Column size={columnSize}>
          {this.state.showModelSelect && (
            <Field
              label="Model"
              placeholder="Search Models"
              fullwidth="true"
              type="select"
              error={this.props.errors[modelID]}
              options={this.state.modelOptions}
              name={modelID}
              id={modelID}
              value={this.props.values[modelID]}
              onChange={({ value }) => {
                this.handleModelChange(value)
              }}
              disabled={!this.state.hasMake}
            />
          )}
          {!this.state.showModelSelect && (
            <Field
              label="Model"
              id={modelID}
              name={modelID}
              placeholder="Model"
              fluidwidth={true}
              error={this.props.errors[modelID]}
              onChange={({ value }) => this.handleModelChange(value)}
              value={this.props.values[modelID]}
            />
          )}
        </Columns.Column>
        <Columns.Column size={columnSize}>
          {this.state.showParkingType && (
            <Field
              label="What Type of Parking is Available for Riders?"
              id={parkingID}
              placeholder="(None Selected)"
              fluidwidth
              type="select"
              error={this.props.errors[parkingID]}
              options={parkingOptions}
              name={parkingID}
              value={this.props.values[parkingID]}
              onChange={({ value }) => {
                this.props.onParkingChange(value)
              }}
              disabled={!this.state.hasMake}
            />
          )}
        </Columns.Column>
      </Columns>
    </div>
  )
  }
}

export default MotoLookUp

MotoLookUp.defaultProps = {
    values : {},
    errors : {},
    columnSize : 12,
    onYearChange : function() {},
    onMakeChange : function() {},
    onModelChange : function() {},
    yearID : null,
    makeID : null,
    modelID : null
}